import { render, staticRenderFns } from "./limitSalesGoods.vue?vue&type=template&id=2c7d7472&scoped=true"
import script from "./limitSalesGoods.vue?vue&type=script&lang=js"
export * from "./limitSalesGoods.vue?vue&type=script&lang=js"
import style0 from "./limitSalesGoods.vue?vue&type=style&index=0&id=2c7d7472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d7472",
  null
  
)

export default component.exports